import type { ReturnLineItem } from '@itsrever/returns-api-types'

// Subtypes the breakdown shows as their own line. A subtype missing from this list still counts
// towards the total but is never shown, so the shopper sees an amount drop with no explanation:
// every new cost subtype must be added here.
const breakdownSubtypes = [
  'RDV_SURPLUS',
  'SERVICE_FEE',
  'ORIGINAL_PROMOTION_BROKEN',
  'EXCHANGE_PROMOTION',
  'RETURN_SHIPPING_COST',
  'ORIGINAL_SHIPPING',
  'KEEP_YOUR_ITEM',
  'INSTANT_EXCHANGE',
  'RETURN_SHIPPING_TAX',
  'EXTERNAL_REFUND',
  'PLATFORM_REFUNDABLE_CAP'
]

export const isBreakdownLineItem = (item: ReturnLineItem): boolean => {
  // A cover promotion that costs nothing is not worth a line of its own.
  if (item.subtype === 'FREE_RETURN_PROMOTION') {
    return Boolean(item.total && item.total > 0)
  }

  return breakdownSubtypes.includes(item.subtype ?? '')
}
